export default "__VITE_ASSET__CMGq7inG__"